//Creating actions to be performed by the admin

export const SET_LOADING = "SET_LOADING";
export const SET_PRODUCT = "SET_PRODUCT";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const SET_SINGLE_PRODUCT = "SET_SINGLE_PRODUCT";
export const VIEW_SINGLE_PRODUCT = "VIEW_SINGLE_PRODUCT";

